import { render, staticRenderFns } from "./SpuLeading.vue?vue&type=template&id=e3645f36&scoped=true"
import script from "./SpuLeading.vue?vue&type=script&lang=ts"
export * from "./SpuLeading.vue?vue&type=script&lang=ts"
import style0 from "./SpuLeading.vue?vue&type=style&index=0&id=e3645f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3645f36",
  null
  
)

export default component.exports